import { createFileRoute } from "@tanstack/react-router";

import CreateGamePage from "~/pages/game/CreateGamePage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/games/")({
    component: CreateGamePage,
});
